import { ColorMap } from "../components/dashboard/types";

export const generateColorMap = (
  uniqueValues: string[],
  colorBy: string
): ColorMap => {
  if (!uniqueValues || uniqueValues.length === 0) return {};

  const colorPalette: [number, number, number][] = [
    [255, 0, 0],
    [0, 0, 255],
    [0, 128, 0],
    [255, 165, 0],
    [128, 0, 128],
    [0, 191, 255],
    [255, 0, 255],
    [255, 255, 0],
    [0, 128, 128],
    [255, 20, 147],

    [128, 128, 0],
    [70, 130, 180],
    [210, 105, 30],
    [0, 250, 154],
    [85, 107, 47],
    [139, 0, 0],
    [72, 61, 139],
    [47, 79, 79],
    [25, 25, 112],
    [0, 0, 128],

    [188, 143, 143],
    [152, 251, 152],
    [255, 222, 173],
    [255, 228, 196],
    [255, 248, 220],
    [240, 128, 128],
    [176, 196, 222],
    [255, 182, 193],
    [221, 160, 221],
    [216, 191, 216],
  ];

  const colorMap: ColorMap = {};
  uniqueValues.forEach((value, index) => {
    const colorIndex = index % colorPalette.length;
    colorMap[value] = colorPalette[colorIndex];
  });

  return colorMap;
};
